import type { FC } from 'react';
import { useState } from 'react';
import { Tabs, Tab, Typography, Container } from '@material-ui/core';
import DashboardCompraDeuda from './DashboardCompraDeuda';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CompraDeuda: FC<any> = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const onChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Container sx={{ p: 0, m: 0 }} maxWidth={false}>
            <Typography component="span">{children}</Typography>
          </Container>
        )}
      </div>
    );
  };

  return (
    <>
      <Tabs value={tabIndex} onChange={onChangeTab}>
        <Tab label="REPORTE COMPRA DEUDA" />
      </Tabs>
      <TabPanel index={0} value={tabIndex}>
        <DashboardCompraDeuda />
      </TabPanel>
    </>
  );
};

export default CompraDeuda;
